/* eslint-disable no-async-promise-executor */
import { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios';

const cacheGetData: Record<string, any> = {};

export const cacheGet = <T>(
  axios: AxiosInstance,
  key: string
): ((url: string, config?: AxiosRequestConfig) => AxiosPromise<T>) => {
  if (cacheGetData[key]) return () => cacheGetData[key];
  return (url: string, config?: AxiosRequestConfig) =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await axios.get<T>(url, config);
        cacheGetData[key] = { ...response };
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
};
